export enum DateType {
  RANGE = 'RANGE',
  RELATIVE = 'RELATIVE'
}
